export const SHOW_AIRLINE_INFORMATION_QUERY_PARAMETER = 'show-airline-booking-reference';
export const SHOW_BAGGAGE_QUERY_PARAMETER = 'show-baggage-information';
export const SHOW_CREATE_INVOICE = 'show-create-invoice';
export const SHOW_FARE_RULES = 'show-fare-rules';
export const SHOW_ITINERARY = 'show-itinerary';
export const SHOW_MAIL = 'show-mail';
export const SHOW_REFUND_STATUS_QUERY_PARAMETER = 'show-refund-status';
export const SHOW_SELF_TRANSFER_GUARANTEE = 'show-self-transfer-guarantee';
